import React from "react";
import { Dimmer, Loader } from "semantic-ui-react";
import { FormattedMessage } from "react-intl";

const Spinner = ({ inline = false, message }: { inline?: boolean, message?: string }) => {
  const Element = inline ? "div" : Dimmer;
  return (
    <Element active inverted>
      <Loader inline={inline ? true : "centered"}>
        <FormattedMessage
          id={"site.spinner.loading"}
          defaultMessage={message ? message : "Loading"}
        />
      </Loader>
    </Element>
  );
};

export default Spinner;
